import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import InitialState, { UpdateCartAction } from '../redux/cart';
import { productCart, removeProductObj } from '../../types';

const initialState: InitialState = {
  products: [],
  productsTotalPrice: 0,
  totalProducts: 0,
  totalQuantity: 0,
};

export const cartSlice = createSlice({
  name: UpdateCartAction,
  initialState: initialState,
  reducers: {
    updateCart: (state, action: PayloadAction<productCart>) => {
      const productData = action.payload;
      const isExistingAddedProduct = state.products.find((prod) => prod.id === productData.id);
      if (isExistingAddedProduct) {
        isExistingAddedProduct.quantity += productData.quantity || 1;
        isExistingAddedProduct.productTotal =
          +isExistingAddedProduct.price * isExistingAddedProduct.quantity;
      } else {
        productData.quantity = productData.quantity || 1;
        productData.productTotal = +productData.price * productData.quantity;
        state.products = [...state.products, productData];
      }
      state.productsTotalPrice = state.products.reduce((acc, curr) => {
        return acc + curr.productTotal;
      }, 0);
      state.totalProducts = state.products.length;
      state.totalQuantity = state.products.reduce((acc, curr) => {
        return acc + curr.quantity;
      }, 0);
      localStorage.setItem('cartDetails', JSON.stringify([...state.products]));
    },
    removeProductFromCart: (state, action: PayloadAction<removeProductObj>) => {
      let tempProducts = state.products;
      tempProducts = tempProducts.filter((prod) => prod.id !== action.payload.id);
      state.products = [...tempProducts];
      state.productsTotalPrice = state.products.reduce((acc, curr) => {
        return acc + curr.productTotal;
      }, 0);
      state.totalProducts = state.products.length;
      state.totalQuantity = state.products.reduce((acc, curr) => {
        return acc + curr.quantity;
      }, 0);
      localStorage.setItem('cartDetails', JSON.stringify([...state.products]));
    },
    updateCartOnPageReload: (state, action: PayloadAction<Array<productCart>>) => {
      const { payload } = action;
      state.products = [...payload];
      state.productsTotalPrice = state.products.reduce((acc, curr) => {
        return acc + curr.productTotal;
      }, 0);
      state.totalProducts = state.products.length;
      state.totalQuantity = state.products.reduce((acc, curr) => {
        return acc + curr.quantity;
      }, 0);
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateCart, removeProductFromCart, updateCartOnPageReload } = cartSlice.actions;
// You must export the reducer as follows for it to be able to be read by the store.
export default cartSlice.reducer;
